// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ApplyConfigurationDirectly_ReadyPlanConfigQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type ApplyConfigurationDirectly_ReadyPlanConfigQuery = { __typename?: 'Query', structure: { __typename?: 'Structure', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string } | null | undefined } };

export type ApplyConfigurationDirectlyMutationVariables = Types.Exact<{
  input: Types.SaveProjectReadyPlanConfigsInput;
}>;


export type ApplyConfigurationDirectlyMutation = { __typename?: 'Mutation', saveProjectReadyPlanConfigs: { __typename?: 'SaveProjectReadyPlanConfigsResult', projectReadyPlanConfigs: Array<{ __typename?: 'ProjectReadyPlanConfig', id: string }> } };


export const ApplyConfigurationDirectly_ReadyPlanConfigDocument = gql`
    query ApplyConfigurationDirectly_ReadyPlanConfig($projectId: ID!) {
  structure(id: $projectId) {
    id
    readyPlanConfig {
      id
    }
  }
}
    `;

/**
 * __useApplyConfigurationDirectly_ReadyPlanConfigQuery__
 *
 * To run a query within a React component, call `useApplyConfigurationDirectly_ReadyPlanConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplyConfigurationDirectly_ReadyPlanConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplyConfigurationDirectly_ReadyPlanConfigQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useApplyConfigurationDirectly_ReadyPlanConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ApplyConfigurationDirectly_ReadyPlanConfigQuery, ApplyConfigurationDirectly_ReadyPlanConfigQueryVariables> & ({ variables: ApplyConfigurationDirectly_ReadyPlanConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ApplyConfigurationDirectly_ReadyPlanConfigQuery, ApplyConfigurationDirectly_ReadyPlanConfigQueryVariables>(ApplyConfigurationDirectly_ReadyPlanConfigDocument, options);
      }
export function useApplyConfigurationDirectly_ReadyPlanConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ApplyConfigurationDirectly_ReadyPlanConfigQuery, ApplyConfigurationDirectly_ReadyPlanConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ApplyConfigurationDirectly_ReadyPlanConfigQuery, ApplyConfigurationDirectly_ReadyPlanConfigQueryVariables>(ApplyConfigurationDirectly_ReadyPlanConfigDocument, options);
        }
// @ts-ignore
export function useApplyConfigurationDirectly_ReadyPlanConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ApplyConfigurationDirectly_ReadyPlanConfigQuery, ApplyConfigurationDirectly_ReadyPlanConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApplyConfigurationDirectly_ReadyPlanConfigQuery, ApplyConfigurationDirectly_ReadyPlanConfigQueryVariables>;
export function useApplyConfigurationDirectly_ReadyPlanConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApplyConfigurationDirectly_ReadyPlanConfigQuery, ApplyConfigurationDirectly_ReadyPlanConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApplyConfigurationDirectly_ReadyPlanConfigQuery | undefined, ApplyConfigurationDirectly_ReadyPlanConfigQueryVariables>;
export function useApplyConfigurationDirectly_ReadyPlanConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApplyConfigurationDirectly_ReadyPlanConfigQuery, ApplyConfigurationDirectly_ReadyPlanConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ApplyConfigurationDirectly_ReadyPlanConfigQuery, ApplyConfigurationDirectly_ReadyPlanConfigQueryVariables>(ApplyConfigurationDirectly_ReadyPlanConfigDocument, options);
        }
export type ApplyConfigurationDirectly_ReadyPlanConfigQueryHookResult = ReturnType<typeof useApplyConfigurationDirectly_ReadyPlanConfigQuery>;
export type ApplyConfigurationDirectly_ReadyPlanConfigLazyQueryHookResult = ReturnType<typeof useApplyConfigurationDirectly_ReadyPlanConfigLazyQuery>;
export type ApplyConfigurationDirectly_ReadyPlanConfigSuspenseQueryHookResult = ReturnType<typeof useApplyConfigurationDirectly_ReadyPlanConfigSuspenseQuery>;
export type ApplyConfigurationDirectly_ReadyPlanConfigQueryResult = ApolloReactCommon.QueryResult<ApplyConfigurationDirectly_ReadyPlanConfigQuery, ApplyConfigurationDirectly_ReadyPlanConfigQueryVariables>;
export const ApplyConfigurationDirectlyDocument = gql`
    mutation ApplyConfigurationDirectly($input: SaveProjectReadyPlanConfigsInput!) {
  saveProjectReadyPlanConfigs(input: $input) {
    projectReadyPlanConfigs {
      id
    }
  }
}
    `;

/**
 * __useApplyConfigurationDirectlyMutation__
 *
 * To run a mutation, you first call `useApplyConfigurationDirectlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyConfigurationDirectlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyConfigurationDirectlyMutation, { data, loading, error }] = useApplyConfigurationDirectlyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyConfigurationDirectlyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApplyConfigurationDirectlyMutation, ApplyConfigurationDirectlyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ApplyConfigurationDirectlyMutation, ApplyConfigurationDirectlyMutationVariables>(ApplyConfigurationDirectlyDocument, options);
      }
export type ApplyConfigurationDirectlyMutationHookResult = ReturnType<typeof useApplyConfigurationDirectlyMutation>;
export type ApplyConfigurationDirectlyMutationResult = ApolloReactCommon.MutationResult<ApplyConfigurationDirectlyMutation>;